export default function compatibleVue() {
  const refs = $("#app [ref]");
  return {
    process() {
      refs.prop("ref", function () {
        return $(this).attr("ref");
      });
    },
    recover() {
      refs.attr("ref", function () {
        return $(this).prop("ref");
      });
    },
  };
}
